import { render, staticRenderFns } from "./ShipmentAddress.vue?vue&type=template&id=7bcd45b1&"
import script from "./ShipmentAddress.vue?vue&type=script&lang=js&"
export * from "./ShipmentAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports